// extracted by mini-css-extract-plugin
export var footerColumn = "styles-module--footerColumn--vtaDh";
export var title = "styles-module--title--rA18B";
export var backAndForthRight = "styles-module--backAndForthRight--55V6w";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--SdNo4";
export var animateBg = "styles-module--animateBg--8Hllk";